function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.202,
    height: 69.27,
    viewBox: "0 0 86.202 69.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "store (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47014",
    d: "M16.008 232.02h80.045v44.64H16.008zm0 0",
    transform: "translate(-12.929 -207.391)",
    style: {
      fill: "#668796"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47015",
    d: "M304.008 232.02h3.079v44.64h-3.079zm0 0",
    transform: "translate(-245.514 -207.391)",
    style: {
      fill: "#4d6877"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47016",
    d: "M48.008 320.02h44.64v13.854h-44.64zm0 0",
    transform: "translate(-38.772 -278.458)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47017",
    d: "M16.008 432.02h56.955v6.157H16.008zm0 0",
    transform: "translate(-12.929 -368.908)",
    style: {
      fill: "#4d6877"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47018",
    d: "M78.513 110.177v-6.157H7.7v6.157L.008 125.57v3.079h86.2v-3.079zm0 0",
    transform: "translate(-.008 -104.02)",
    style: {
      fill: "#5cc4a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47019",
    d: "M40.008 104.02h70.809v6.157H40.008zm0 0",
    transform: "translate(-32.311 -104.02)",
    style: {
      fill: "#239172"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47022",
    d: "M.008 232.02v5.388a5.454 5.454 0 0 0 5.392 5.387 5.454 5.454 0 0 0 5.388-5.388v-5.387",
    transform: "translate(-.008 -207.391)",
    style: {
      fill: "#2ab793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47023",
    d: "M66.783 232.02v5.388a5.388 5.388 0 1 1-10.775 0v-5.388",
    transform: "translate(-45.233 -207.391)",
    style: {
      fill: "#f7d289"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47024",
    d: "M122.783 232.02v5.388a5.388 5.388 0 1 1-10.775 0v-5.388",
    transform: "translate(-90.457 -207.391)",
    style: {
      fill: "#2ab793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47025",
    d: "M178.783 232.02v5.388a5.388 5.388 0 1 1-10.775 0v-5.388",
    transform: "translate(-135.682 -207.391)",
    style: {
      fill: "#f7d289"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47026",
    d: "M224.008 232.02v5.388a5.388 5.388 0 1 0 10.775 0v-5.388",
    transform: "translate(-180.907 -207.391)",
    style: {
      fill: "#2ab793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47027",
    d: "M280.008 232.02v5.388a5.388 5.388 0 1 0 10.775 0v-5.388",
    transform: "translate(-226.132 -207.391)",
    style: {
      fill: "#f7d289"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47028",
    d: "M336.008 232.02v5.388a5.388 5.388 0 1 0 10.775 0v-5.388",
    transform: "translate(-271.356 -207.391)",
    style: {
      fill: "#2ab793"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47029",
    d: "M392.008 232.02v5.388a5.388 5.388 0 1 0 10.775 0v-5.388",
    transform: "translate(-316.581 -207.391)",
    style: {
      fill: "#f7d289"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14536"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47030",
    d: "M206.165 333.873h-6.157l13.854-13.854h1.538v4.618zm0 0",
    transform: "translate(-161.525 -278.459)",
    style: {
      fill: "#e4e7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47031",
    d: "M142.165 333.873h-6.157l13.854-13.854h6.157zm0 0",
    transform: "translate(-109.839 -278.459)",
    style: {
      fill: "#e4e7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47032",
    d: "M78.165 333.873h-6.157l13.854-13.853h6.157zm0 0",
    transform: "translate(-58.154 -278.459)",
    style: {
      fill: "#e4e7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47033",
    d: "M48.008 332.334v-6.157l6.157-6.157h6.157zm0 0",
    transform: "translate(-38.772 -278.459)",
    style: {
      fill: "#e4e7ea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47034",
    d: "M336.008 304.02H351.4v27.708h-15.392zm0 0",
    transform: "translate(-271.356 -265.537)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47035",
    d: "M336.008 352.02h3.079v3.08h-3.079zm0 0",
    transform: "translate(-271.356 -304.301)",
    style: {
      fill: "#668796"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47036",
    d: "M336.008 341.57v-6.157L351.4 320.02v6.157zm0 0",
    transform: "translate(-271.356 -278.458)",
    style: {
      fill: "#e4e7ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47037",
    d: "M366.165 402.795h-6.157l10.775-10.775v6.157zm0 0",
    transform: "translate(-290.738 -336.604)",
    style: {
      fill: "#e4e7ea"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon);
export default __webpack_public_path__ + "static/media/storeIcon.176eed0c46145d43abb02c10391bad8a.svg";
export { ForwardRef as ReactComponent };